/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ContainerIdRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ContainerIdRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return ContainerIdRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ContainerIdRegexQueryOperator>): ContainerIdRegexQueryOperator {
        let obj = Object.assign(new ContainerIdRegexQueryOperator(), model);
        ContainerIdRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ContainerIdRegexQueryOperator>): ContainerIdRegexQueryOperator {
        if (!model) return null;
        return ContainerIdRegexQueryOperator.newInstance(<ContainerIdRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ContainerIdRegexQueryOperator) {
        if (!obj) return;

        models.ContainerIdRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ContainerIdRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ContainerIdRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.container_id_regex) {
            models.Regex.fixupPrototype(this.container_id_regex);
        }
    }

    /**
     * Kubernetes Container ID by regex match (resource_id, resource_group=Container)
     */
    container_id_regex: models.Regex;

}
